import { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import stile from './pruefhinweis-dialog.module.css';

export interface VerwerfenDialogProps {
  onBestaetigen(): void;
  /** Auch Esc und jedes andere Schliessen landen hier (`close`-Ereignis). */
  onAbbrechen(): void;
}

/**
 * Rueckfrage, bevor die Wahl "Fassung der Content Engine" die eigene Bearbeitung verwirft
 * (Codex-Gate PR #70): Eine Auswahlliste laesst sich per Tastatur leicht versehentlich umstellen,
 * und sie legt nahe, dass beide Fassungen erhalten bleiben. Aufbau wie `PruefhinweisDialog`:
 * natives <dialog> per Portal an `body`, der sichere Weg steht zuerst und ist fokussiert.
 */
export function VerwerfenDialog({ onBestaetigen, onAbbrechen }: VerwerfenDialogProps) {
  const dialog = useRef<HTMLDialogElement>(null);
  const titelId = useId();
  useEffect(() => {
    const element = dialog.current;
    if (element && !element.open) element.showModal();
  }, []);
  return createPortal(
    <dialog ref={dialog} className={stile.dialog} aria-labelledby={titelId} onClose={onAbbrechen}>
      <h2 id={titelId} className={stile.titel}>
        Ihre Bearbeitung verwerfen?
      </h2>
      <p className={stile.satz}>
        Ihre Änderungen am Text gehen dabei verloren. Danach gilt wieder die Fassung der Content
        Engine.
      </p>
      <div className={stile.aktionen}>
        <button
          type="button"
          className="eds-button eds-button--secondary"
          onClick={() => dialog.current?.close()}
        >
          Abbrechen
        </button>
        <button type="button" className="eds-button eds-button--primary" onClick={onBestaetigen}>
          Bearbeitung verwerfen
        </button>
      </div>
    </dialog>,
    document.body,
  );
}
